import React from 'react'
import PropTypes from 'prop-types'

import { SpinnerComponent as Spinner } from '../../../sharedLegacy/components'

const AudienceFoyerLoaderComponent = ({ children, isLoading = false }) => {
  return isLoading ? <Spinner /> : children
}

AudienceFoyerLoaderComponent.propTypes = {
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
}

export default AudienceFoyerLoaderComponent
